// extracted by mini-css-extract-plugin
export var iconLightBlueBackground = "loading-module--icon-light-blue-background--BQ396";
export var iconGradientBlueBackground = "loading-module--icon-gradient-blue-background--2Elfj";
export var iconWhiteBackground = "loading-module--icon-white-background--3NY_I";
export var loadingContainer = "loading-module--loadingContainer--35QfI";